module.exports = __webpack_public_path__ + "img/calendar-schedule.a16fcc96.webp";